/**
 * Placeholder shown in any composer that supports the "/" support-template
 * picker, so every surface (support reply box, applicant comms, text entry
 * questions) advertises templates with the same wording. Returns undefined
 * when there are no templates to pick from.
 */
export function supportTemplateHint(
  comms: { type_your_message_here: string, use_slash_for_templates: string },
  templateCount: number,
): string | undefined {
  return templateCount > 0
    ? `${comms.type_your_message_here} ${comms.use_slash_for_templates}`
    : undefined;
}
